import AppNavigator from './AppNavigator'

export default AppNavigator
